import React, { useState, useContext, useEffect } from 'react';

import i18n from 'i18n-js';
import PropTypes from 'prop-types';
import { Card } from 'components/UI';
import { UserContext } from 'context';
import EditIcon from '@material-ui/icons/Edit';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { useDispatch, useSelector } from 'react-redux';
import { vehicleActions } from 'state/modules/vehicles';
import { ListItem, ListItemText } from '@material-ui/core';
import EditAssignedGroupModal from './EditAssignedGroupModal';
import VehiclesGroupsLabel from 'components/VehiclesGroups/VehicleGroupsLabel';
import { listItemsStyles, listTextStyles, customCardStyles } from './AssignedGroupsWidget.styled';
import { FETCH_STATE } from 'constants';

export const AssignedGroupsWidget = ({
  menuOptions = [],
  vehicle_id,
  vehicle_group,
  params = {},
}) => {
  const { orgType } = useContext(UserContext);
  const [modalOpen, setModalOpen] = useState(false);
  const dispatch = useDispatch();
  const listClasses = listTextStyles();
  const listItemsClasses = listItemsStyles();
  const cardClasses = customCardStyles();
  const isOwner = orgType === 'msOwnerOrg';
  const toggleModal = () => {
    setModalOpen((prevState) => !prevState);
  };
  const fetchUpdateVehicleGroup = useSelector((state) => state.vehicles?.fetchUpdateVehicleGroup);
  const loading = useSelector((state) => state.vehicles?.loading);

  const onEditGroup = (vehicle_group_id) =>
    dispatch(vehicleActions.updateVehicleGroup(vehicle_id, vehicle_group_id));

  const refetch = fetchUpdateVehicleGroup === FETCH_STATE.DONE;

  useEffect(() => {
    if (refetch) {
      dispatch(vehicleActions.fetchVehicleById(vehicle_id));
      setModalOpen(false);
    }
  }, [refetch]);

  return (
    <>
      {modalOpen && (
        <EditAssignedGroupModal
          params={params}
          open={modalOpen}
          isOwner={isOwner}
          onCancel={toggleModal}
          onConfirm={onEditGroup}
          vehicleGroupId={vehicle_group?.id}
        />
      )}
      <Card
        menuItems={menuOptions}
        title={VehiclesGroupsLabel({ plural: true })}
        headerActionType="vertical"
        contentRootClasses={cardClasses}
        loading={loading}
        data-cy="vehicle-group-widget"
      >
        <ListItem key={vehicle_group.id} classes={listItemsClasses}>
          <ListItemText
            classes={listClasses}
            primary={vehicle_group.name}
            secondary={
              isOwner || vehicle_group.parent ? (
                <Tooltip title={i18n.t('common.edit')}>
                  <IconButton size="small" aria-haspopup="true" onClick={toggleModal}>
                    <EditIcon style={{ fontSize: 18 }} />
                  </IconButton>
                </Tooltip>
              ) : null
            }
          />
        </ListItem>
        {vehicle_group.parent ? (
          <ListItem key={`vg-${vehicle_group.id}`} classes={listItemsClasses}>
            <ListItemText classes={listClasses} primary={vehicle_group.parent.name} />
          </ListItem>
        ) : null}
      </Card>
    </>
  );
};

AssignedGroupsWidget.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
};
